'use client';

import { c as _c } from "react/compiler-runtime";
import { getCountryCodeFromLocale, PHONE_COUNTRIES, REGION_CODES } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import type { ParseKeys } from 'i18next';
import { forwardRef, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import mergeRefs from 'react-merge-refs';
import { useUpdateEffect } from 'usehooks-ts';
import type { BaseSelectOption } from '../internal/base-select';
import BaseSelect from '../internal/base-select';
import Input from './components/input';
import MobileOption from './components/mobile-option';
import Option from './components/option';
import type { PhoneInputProps, PhoneSelectOption } from './phone-input.types';
import { getCountryFromPhoneNumber } from './phone-input.utils';
const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>((t0, ref) => {
  const $ = _c(38);
  let hasError;
  let hint;
  let locale;
  let onReset;
  let props;
  let searchPlaceholder;
  let selectEmptyStateText;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      hasError,
      hint,
      onReset,
      searchPlaceholder,
      selectEmptyStateText,
      value,
      locale,
      popper: t1,
      options: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = hasError;
    $[2] = hint;
    $[3] = locale;
    $[4] = onReset;
    $[5] = props;
    $[6] = searchPlaceholder;
    $[7] = selectEmptyStateText;
    $[8] = t1;
    $[9] = t2;
    $[10] = value;
  } else {
    hasError = $[1];
    hint = $[2];
    locale = $[3];
    onReset = $[4];
    props = $[5];
    searchPlaceholder = $[6];
    selectEmptyStateText = $[7];
    t1 = $[8];
    t2 = $[9];
    value = $[10];
  }
  const popper = t1 === undefined ? false : t1;
  const options = t2 === undefined ? PHONE_COUNTRIES : t2;
  const {
    t
  } = useTranslation("ui");
  const localRef = useRef(null);
  let t3;
  if ($[11] !== locale || $[12] !== value) {
    t3 = () => getCountryFromPhoneNumber(value, getCountryCodeFromLocale(locale));
    $[11] = locale;
    $[12] = value;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const [selectedCountry, setCountry] = useState(t3);
  const countryCode = selectedCountry.value;
  let t4;
  if ($[14] !== onReset) {
    t4 = newOption => {
      setCountry(newOption);
      onReset?.();
    };
    $[14] = onReset;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const handleCountryChange = t4;
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      localRef.current?.focus();
    };
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== countryCode) {
    t6 = [countryCode];
    $[17] = countryCode;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  useUpdateEffect(t5, t6);
  let t7;
  if ($[19] !== options || $[20] !== t) {
    const getCountriesWithLocalizedLabels = () => options.map(option => ({
      ...option,
      label: t(`global.countries.${option.value}` as ParseKeys<'ui'>)
    }));
    t7 = getCountriesWithLocalizedLabels();
    $[19] = options;
    $[20] = t;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const localizedOptions = t7;
  let t8;
  if ($[22] !== countryCode || $[23] !== hasError || $[24] !== props || $[25] !== ref || $[26] !== value) {
    t8 = trigger => <Input {...props} countryCode={countryCode} hasError={hasError} prefix={REGION_CODES[countryCode]} ref={mergeRefs([ref, localRef])} value={value} selectTrigger={{
      isOpen: trigger.isOpen,
      onClick: trigger.onClick
    }} />;
    $[22] = countryCode;
    $[23] = hasError;
    $[24] = props;
    $[25] = ref;
    $[26] = value;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== handleCountryChange || $[29] !== hasError || $[30] !== hint || $[31] !== localizedOptions || $[32] !== popper || $[33] !== searchPlaceholder || $[34] !== selectEmptyStateText || $[35] !== selectedCountry || $[36] !== t8) {
    t9 = <BaseSelect emptyStateText={selectEmptyStateText} hasError={hasError} hint={hint} onChange={handleCountryChange} OptionComponent={Option} options={localizedOptions} MobileOptionComponent={MobileOption} popper={popper} renderTrigger={t8} searchPlaceholder={searchPlaceholder} value={selectedCountry} />;
    $[28] = handleCountryChange;
    $[29] = hasError;
    $[30] = hint;
    $[31] = localizedOptions;
    $[32] = popper;
    $[33] = searchPlaceholder;
    $[34] = selectEmptyStateText;
    $[35] = selectedCountry;
    $[36] = t8;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  return t9;
});
export default PhoneInput;